module.exports = __webpack_public_path__ + "static/img/TH.4c61314.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/TH.png
// module id = J/Rs
// module chunks = 1